module.exports = __webpack_public_path__ + "img/product_19.16e4584.webp";